module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kmAVa"))).then(() => parcelRequire('1iHdE'));